<app-navbar></app-navbar>

<core-loader mode="indeterminate"></core-loader>

<router-outlet></router-outlet>
